<mat-dialog-content class="loren-asset-details-photos-dialog">
  <div class="loren-asset-details-photos-dialog-header">
    <h4 class="loren-asset-details-photos-dialog-title">
      {{ data.assetName }}
    </h4>
    <div class="loren-asset-details-photos-dialog-count-container">
      <span class="loren-asset-details-photos-dialog-count">
        {{ data.currentPhoto + 1 }} {{ "From" | transloco }}
        {{ data.allPhotos.length }}
        {{ "asset_details.photos" | transloco | lowercase }}
      </span>
      <mat-icon
        class="loren-asset-details-photos-dialog-close"
        (click)="onCancel()">
        close
      </mat-icon>
    </div>
  </div>
  <div class="loren-asset-details-photos-dialog-main">
    <div>
      @if(data.currentPhoto !== 0) {
      <mat-icon
        class="loren-asset-details-photos-dialog-main-arrows"
        (click)="updateCurrentPhoto(data.allPhotos[data.currentPhoto - 1])">
        keyboard_arrow_left
      </mat-icon>
      }
    </div>
    <div>
      <img
        class="loren-asset-details-photos-dialog-image"
        [src]="data.allPhotos[data.currentPhoto].fileImage"
        alt="Asset image"
      />
    </div>
    <div>
      @if(data.currentPhoto !== data.allPhotos.length - 1) {
      <mat-icon
        class="loren-asset-details-photos-dialog-main-arrows"
        (click)="updateCurrentPhoto(data.allPhotos[data.currentPhoto + 1])">
        keyboard_arrow_right
      </mat-icon>
      }
    </div>
    <div class="loren-asset-details-photos-dialog-info">
      <span class="loren-asset-details-photos-dialog-key">
        {{ "asset_details.updated" | transloco }}:
      </span>
      <span class="loren-asset-details-photos-dialog-date">{{
        data.allPhotos[data.currentPhoto].createdOn | lorenDate
      }}</span>
      <span class="loren-asset-details-photos-dialog-key">
        {{ "asset_details.updated_by" | transloco }}:
      </span>
      <span class="loren-asset-details-photos-dialog-value">{{
        data.allPhotos[data.currentPhoto].createdBy
      }}</span>
      <span class="loren-asset-details-photos-dialog-key"
        >{{ "asset_details.status" | transloco }}:
      </span>
      <span
        class="loren-asset-details-photos-dialog-value"
        [style.color]="
          data.allPhotos[data.currentPhoto].assetCondition === 'VERY_GOOD'
            ? '#00966E'
            : data.allPhotos[data.currentPhoto].assetCondition === 'BAD' ||
              data.allPhotos[data.currentPhoto].assetCondition === 'VERY_BAD'
            ? '#E11D48'
            : '#000'
        "
        >{{
          "statuses." +
            data.allPhotos[data.currentPhoto].assetCondition.toLowerCase()
            | transloco
        }}</span
      >
      <span class="loren-asset-details-photos-dialog-key"
        >{{ "asset_details.comment" | transloco }}:
      </span>
      <span class="loren-asset-details-photos-dialog-value">{{
        data.allPhotos[data.currentPhoto].comment
      }}</span>
    </div>
  </div>
  @if(!isHandset) {
  <div class="loren-asset-details-photos-dialog-carousel">
    <div>
      @if(carouselBack()) {
      <mat-icon
        class="loren-asset-details-photos-dialog-carousel-arrow"
        (click)="carouselStart()"
        >keyboard_arrow_left</mat-icon
      >
      }
    </div>
    <div class="loren-asset-details-photos-dialog-carousel-photos">
      @for(photo of visiblePhotosInCarousel(); track photo;) {
      <button
        type="button"
        class="loren-asset-details-photos-dialog-carousel-photo"
        (click)="updateCurrentPhoto(photo)">
        <img alt="Asset image"
          class="loren-asset-details-photos-dialog-carousel-image"
          [src]="photo.fileImageThumbnail"
          [ngClass]="{
            'loren-asset-details-photos-dialog-carousel-image--inactive':
              data.allPhotos[data.currentPhoto].id !== photo.id
          }" />
        <div class="loren-asset-details-photos-dialog-carousel-overlay">
          {{ getPhotoNumber(photo) + 1 }}
        </div>
      </button>
      }
    </div>
    <div>
      @if(carouselForward()) {
      <mat-icon
        class="loren-asset-details-photos-dialog-carousel-arrow"
        (click)="carouselEnd()"
        >keyboard_arrow_right</mat-icon
      >
      }
    </div>
  </div>
  }
</mat-dialog-content>
